<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="your-name-is-written">
<h1>Your Name Is Written</h1>
<p style="text-indent:0em">Your name is written</p>
<p style="text-indent:0em">On a piece of paper</p>
<p style="text-indent:0em">Your task is to tear away</p>
<p style="text-indent:0em">The surrounding paper</p>
<p style="text-indent:0em">Until there is only the word remaining</p>
<p style="text-indent:0em">When there are blank areas, it is easy</p>
<p style="text-indent:0em">But as you close in closer to the name</p>
<p style="text-indent:0em">You will inevitably because</p>
<p style="text-indent:0em">You have to keep going</p>
<p style="text-indent:0em">Tear off part of a letter or several letters together</p>
<p style="text-indent:0em">Until the word is gone altogether</p>
<p style="text-indent:0em">Then you have no paper and no name</p>
<br/>
<p style="text-indent:0em">Or consider this situation</p>
<p style="text-indent:0em">The name on the paper, your name is written</p>
<p style="text-indent:0em">Invades as it were the blank region</p>
<p style="text-indent:0em">As a city gives its name to a whole region</p>
<p style="text-indent:0em">And spreads out on empty land</p>
<p style="text-indent:0em">Empty in the sense of that’s where the rural population live</p>
<p style="text-indent:0em">Teaming with agriculture and day trippers</p>
<p style="text-indent:0em">But empty in the eyes of land grab</p>
<p style="text-indent:0em">So the name is the entire piece of paper</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?5a9eca5d